import React, { useMemo } from 'react';
import {
  MENU_SEARCH_TAXONOMY_COOKING,
  MENU_SEARCH_TAXONOMY_NONE_COOKING,
  MENU_TAXONOMY_COOKING,
  MENU_TAXONOMY_NONE_COOKING
} from '@/constants/app';
import MenuTaxonomyCategoryList from '@/components/menus/MenuTaxonomyCategoryList';
import useMenuTaxonomyList from '@/hooks/useMenuTaxonomyList';

const MenuTaxonomyCategoryListContainer = () => {
  const menuTaxonomyList = useMenuTaxonomyList();
  const contents = useMemo(
    () => [
      {
        title: MENU_SEARCH_TAXONOMY_COOKING,
        list: menuTaxonomyList.filter((item) => item.fields.type === MENU_TAXONOMY_COOKING) || []
      },
      {
        title: MENU_SEARCH_TAXONOMY_NONE_COOKING,
        list:
          menuTaxonomyList.filter((item) => item.fields.type === MENU_TAXONOMY_NONE_COOKING) || []
      }
    ],
    [menuTaxonomyList]
  );
  return (
    <>
      {contents.map((item) => {
        return (
          <MenuTaxonomyCategoryList title={item.title} taxonomyList={item.list} key={item.title} />
        );
      })}
    </>
  );
};

export default MenuTaxonomyCategoryListContainer;
